// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BvA7","question":"styles_question__2HekX","description":"styles_description__2docw"};